import type { IconProps } from './types';

function MinusIcon(props: IconProps) {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/20000/svg"
      {...other}
      ref={ref}
    >
      <path d="M1.6875 12H22.3125" stroke={color} strokeWidth="1.5" />
    </svg>
  );
}

export { MinusIcon };
